import get from 'lodash.get';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectFulfillments = (state) => get(state, 'fulfillments', emptyArray);
export const selectLoading = (state) => get(state, 'loading', false);
export const selectSuccessfullyVoided = (state) => get(state, 'successfullyVoided', emptyArray);
export const selectVoidWarnings = (state) => get(state, 'voidWarnings', emptyArray);
